export default "__VITE_ASSET__4e6de03b__"